let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fW7Gt")).then(() => parcelRequire('iE4r7'));